export function makeVariant(event, variant) {
	return {
		...event,
		category: variant ? `${event.category}/${variant}` : event.category,
	};
}
